<template>
    <div class="modal fade  bonus-point-modal" id="walleteditstackModal" tabindex="-1" aria-labelledby="WalletModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content wallet-edit-stake-modal  change-language-modal">
                <div class="modal-header border-blow">
                    <div class="thm-heading">
                        <h3>{{ $t('edit-stake', 'Edit Stake') }}</h3>
                    </div>
                </div>
                <div class="modal-body">
                    <div class="stakeed-sec withdraw-sec bg-transparent p-0 border-0 singlestakeed-sec">
                        <div class="exch-setting-edit-stack-wrapper">
                            <div class="exch-setting-edit-stakes-input-section mobile-input mt-0" v-if="stake">
                                <input v-model="stake[i-1]" v-for="i in stake?.length" :key="i" class="btn-thm m-auto" maxlength="8" @input="stake[i-1] = $helper.sanitizeNumber(stake[i-1], 10000000)">
                            </div>
                        </div>
                    </div>

                    <div class="two-btns mt-3">
                        <ul class="cmn-ul-list">
                            <li class="w-50">
                                <button class="btn thm-bor-but cancel-lang-btn " data-bs-dismiss="modal" type="button" @click="resetChips()"> {{ $t('cancel', 'Cancel') }}</button>
                            </li>
                            <li  class="w-50">
                                <button class="btn thm-but update-btn12" @click="callChangeStakeValue()"> {{ $t('save', 'Save') }}</button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "WalletStackModal",
    props: ['stakes'],
    data() {
        return {
            stake: JSON.parse(JSON.stringify(this.$store.getters.userTransactionStakes || this.stakes))
        };
    },
    emits: ['close-stake-modal', 'save-btn'],
    mounted() {
        this.resetChips();
    },
    methods: {
        callChangeStakeValue() {
            if(Object.values(this.stake).some(item => item == '') || Object.values(this.stake).some(item => item < 100)){
                this.$errorToast('Stake value must be between 100 to 1Cr.')
                return

            }
            this.$store.dispatch('setUserTransactionStakes', JSON.parse(JSON.stringify(this.stake)));
            this.$successToast('Saved Successfully')
            this.$helper.closeModal('walleteditstackModal');
        },
        resetChips(){
            this.stake = JSON.parse(JSON.stringify(this.$store.getters.userTransactionStakes || this.stakes));
        }
    }
};
</script>